import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { Array as ArrayT } from './Array.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
export var LazyArray = /*#__PURE__*/function (_ArrayT) {
  _inherits(LazyArray, _ArrayT);
  function LazyArray() {
    _classCallCheck(this, LazyArray);
    return _possibleConstructorReturn(this, _getPrototypeOf(LazyArray).apply(this, arguments));
  }
  _createClass(LazyArray, [{
    key: "decode",
    value: function decode(stream, parent) {
      var pos = stream.pos;
      var length = utils.resolveLength(this.length, stream, parent);
      if (this.length instanceof NumberT) {
        parent = {
          parent: parent,
          _startOffset: pos,
          _currentOffset: 0,
          _length: length
        };
      }
      var res = new LazyArrayValue(this.type, length, stream, parent);
      stream.pos += length * this.type.size(null, parent);
      return res;
    }
  }, {
    key: "size",
    value: function size(val, ctx) {
      if (val instanceof LazyArrayValue) {
        val = val.toArray();
      }
      return _superPropGet(LazyArray, "size", this, 3)([val, ctx]);
    }
  }, {
    key: "encode",
    value: function encode(stream, val, ctx) {
      if (val instanceof LazyArrayValue) {
        val = val.toArray();
      }
      return _superPropGet(LazyArray, "encode", this, 3)([stream, val, ctx]);
    }
  }]);
  return LazyArray;
}(ArrayT);
var LazyArrayValue = /*#__PURE__*/function () {
  function LazyArrayValue(type, length, stream, ctx) {
    _classCallCheck(this, LazyArrayValue);
    this.type = type;
    this.length = length;
    this.stream = stream;
    this.ctx = ctx;
    this.base = this.stream.pos;
    this.items = [];
  }
  _createClass(LazyArrayValue, [{
    key: "get",
    value: function get(index) {
      if (index < 0 || index >= this.length) {
        return undefined;
      }
      if (this.items[index] == null) {
        var pos = this.stream.pos;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
        this.items[index] = this.type.decode(this.stream, this.ctx);
        this.stream.pos = pos;
      }
      return this.items[index];
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var result = [];
      for (var i = 0, end = this.length; i < end; i++) {
        result.push(this.get(i));
      }
      return result;
    }
  }]);
  return LazyArrayValue;
}();